import React, { Component } from 'react';
import { AppDataContext } from '../../context/Context';
import { Alert, Snackbar, AlertTitle } from '@mui/material';

class AlertWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            message: '',
            type: '',
            severity: ''
        };
    }
    componentDidMount() {
        this.unsubscribe = this.context.subscribe(() => {
            const message = this.context.getState().alertError.message;
            const type = this.context.getState().alertError.type;
            const severity = this.context.getState().alertError.severity;
            this.setState({ message, type, severity });
        });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    static contextType = AppDataContext;

    render() {
        const { message, type, severity } = this.state;
        const closeSnackbar = () =>
            this.context.update({ alertError: { message: '' } });
        
        const color = severity ? severity : 'error';

        return (
            <>
                {type === 'dialog' ? (
                    message ? (
                        <Alert severity={color}>
                            <AlertTitle>Error</AlertTitle>
                            {message}
                        </Alert>
                    ) : (
                        <div></div>
                    )
                ) : (
                    <Snackbar
                        open={!!message}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                        onClose={() => closeSnackbar()}
                        color={color}
                    >
                        {message ? (
                            <Alert
                                severity={color}
                                onClose={() => closeSnackbar()}
                            >
                                {message}
                            </Alert>
                        ) : (
                            <div></div>
                        )}
                    </Snackbar>
                )}
            </>
        );
    }
}

export default AlertWrapper;
